/* Axial Shift theme interactions: header dropdowns + mobile menu, feature carousel, differentiators,
   filters (FAQ / customers / blog), FAQ accordion, pricing toggle, video modal, rail scroll. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var desktop = function () { return window.matchMedia('(min-width: 1100px)').matches; };

  function initHeader(root) {
    $$('.ax-dd', root).forEach(function (dd) {
      if (dd.__ax) return; dd.__ax = 1;
      var trig = $('.ax-dd__trigger', dd);
      var open = function () { dd.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true'); };
      var close = function () { dd.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); };
      dd.addEventListener('mouseenter', function () { if (desktop()) open(); });
      dd.addEventListener('mouseleave', function () { if (desktop()) close(); });
      trig.addEventListener('focus', function () { if (desktop()) open(); });
      dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) close(); });
      trig.addEventListener('click', function (e) {
        // Links (e.g. Platform) navigate on desktop; on mobile the first tap expands.
        if (trig.tagName === 'A' && desktop()) return;
        if (trig.tagName === 'A' && !dd.classList.contains('is-open')) { e.preventDefault(); open(); return; }
        if (trig.tagName !== 'A') { e.preventDefault(); dd.classList.contains('is-open') ? close() : open(); }
      });
    });
    $$('.ax-burger', root).forEach(function (b) {
      if (b.__ax) return; b.__ax = 1;
      b.addEventListener('click', function () {
        var h = b.closest('.ax-header'); var on = !h.classList.contains('is-menu-open');
        h.classList.toggle('is-menu-open', on); b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
  }

  function initCarousel(root) {
    $$('[data-ax-carousel]', root).forEach(function (c) {
      if (c.__ax) return; c.__ax = 1;
      var slides = $$('.ax-car__slide', c), tabs = $$('.ax-car__tab', c), dots = $$('.ax-car__dot', c);
      var n = slides.length, i = 0, timer = null;
      var interval = parseInt(c.getAttribute('data-autoplay') || '0', 10);
      function go(k, user) {
        if (!n) return; i = (k + n) % n;
        slides.forEach(function (s, j) { s.hidden = j !== i; });
        tabs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        if (user) stop();
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      tabs.forEach(function (t, j) { t.addEventListener('click', function () { go(j, true); }); });
      dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j, true); }); });
      var p = $('[data-ax-prev]', c), nx = $('[data-ax-next]', c);
      if (p) p.addEventListener('click', function () { go(i - 1, true); });
      if (nx) nx.addEventListener('click', function () { go(i + 1, true); });
      go(0);
      if (interval > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && !window.Shopify?.designMode) {
        timer = setInterval(function () { go(i + 1); }, interval * 1000);
        c.addEventListener('mouseenter', stop); c.addEventListener('focusin', stop);
      }
      c.addEventListener('shopify:block:select', function (e) {
        var idx = slides.findIndex(function (s) { return s.contains(e.target) || s === e.target; });
        if (idx >= 0) go(idx, true);
      });
    });
  }

  function initDiff(root) {
    $$('[data-ax-diff]', root).forEach(function (w) {
      if (w.__ax) return; w.__ax = 1;
      var circles = $$('.ax-diff__circle', w), bodies = $$('.ax-diff__body', w);
      function act(k) {
        circles.forEach(function (c, j) { c.classList.toggle('is-active', j === k); c.setAttribute('aria-pressed', j === k ? 'true' : 'false'); });
        bodies.forEach(function (b, j) { b.hidden = j !== k; });
      }
      circles.forEach(function (c, j) { c.addEventListener('mouseenter', function () { act(j); }); c.addEventListener('click', function () { act(j); }); c.addEventListener('focus', function () { act(j); }); });
      act(0);
    });
  }

  /* Generic filter: [data-ax-filter="group"] wraps chips (.ax-chip[data-cat]) + optional search input [data-ax-search];
     items anywhere on the page with [data-ax-filter-item="group"] and data-cats="a|b" data-text="..." */
  function initFilters(root) {
    $$('[data-ax-filter]', root).forEach(function (f) {
      if (f.__ax) return; f.__ax = 1;
      var g = f.getAttribute('data-ax-filter');
      var chips = $$('.ax-chip', f), input = $('[data-ax-search]', f), count = $('[data-ax-count]', f);
      var cat = 'All', q = '';
      function items() { return $$('[data-ax-filter-item="' + g + '"]'); }
      function apply() {
        var n = 0, ql = q.toLowerCase();
        items().forEach(function (it) {
          var cats = (it.getAttribute('data-cats') || '').split('|');
          var ok = (cat === 'All' || cats.indexOf(cat) >= 0) && (!ql || (it.getAttribute('data-text') || it.textContent).toLowerCase().indexOf(ql) >= 0);
          it.hidden = !ok; if (ok) n++;
        });
        if (count) count.textContent = n + (n === 1 ? ' ' + (count.dataset.one || 'question') : ' ' + (count.dataset.many || 'questions'));
        $$('[data-ax-empty="' + g + '"]').forEach(function (e) { e.hidden = n !== 0; });
        $$('[data-ax-faq-group="' + g + '"]').forEach(function (grp) { // hide empty list wrappers
          var vis = $$('[data-ax-filter-item]', grp).some(function (x) { return !x.hidden; });
          grp.classList.toggle('is-empty', !vis);
        });
        document.dispatchEvent(new CustomEvent('ax:filtered', { detail: { group: g } }));
      }
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          cat = c.getAttribute('data-cat') || 'All';
          chips.forEach(function (x) { x.classList.toggle('is-active', x === c); x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          apply();
        });
      });
      if (input) input.addEventListener('input', function () { q = input.value; apply(); });
      apply();
    });
  }

  function initFaq(root) {
    $$('.ax-faq__btn', root).forEach(function (b) {
      if (b.__ax) return; b.__ax = 1;
      b.addEventListener('click', function () {
        var item = b.closest('[data-ax-faq-item]'); var a = $('.ax-faq__a', item); var on = a.hidden;
        $$('[data-ax-faq-item]').forEach(function (it) { var x = $('.ax-faq__a', it); if (x && it !== item) { x.hidden = true; $('.ax-faq__sign', it).textContent = '+'; $('.ax-faq__btn', it).setAttribute('aria-expanded', 'false'); } });
        a.hidden = !on; $('.ax-faq__sign', item).textContent = on ? '−' : '+'; b.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
    });
    document.addEventListener('ax:filtered', function () {
      $$('[data-ax-faq-item]').forEach(function (it) { var x = $('.ax-faq__a', it); if (x) { x.hidden = true; $('.ax-faq__sign', it).textContent = '+'; } });
    });
  }

  function initPricing(root) {
    $$('[data-ax-pricing]', root).forEach(function (p) {
      if (p.__ax) return; p.__ax = 1;
      $$('.ax-seg', p).forEach(function (s) {
        s.addEventListener('click', function () {
          var y = s.getAttribute('data-yearly') === '1';
          p.classList.toggle('is-yearly', y);
          $$('.ax-seg', p).forEach(function (x) { x.classList.toggle('is-active', x === s); x.setAttribute('aria-pressed', x === s ? 'true' : 'false'); });
        });
      });
    });
  }

  function initVideo() {
    var m = $('[data-ax-video-modal]'); if (!m) return;
    var f = $('iframe', m);
    function close() { m.hidden = true; f.src = ''; document.documentElement.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-ax-video]');
      if (t) { e.preventDefault(); f.src = t.getAttribute('data-ax-video'); m.hidden = false; document.documentElement.style.overflow = 'hidden'; return; }
      if (e.target === m || e.target.closest('[data-ax-video-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
  }

  function initRails(root) {
    $$('[data-ax-rail-prev], [data-ax-rail-next]', root).forEach(function (b) {
      if (b.__ax) return; b.__ax = 1;
      b.addEventListener('click', function () {
        var r = b.closest('section').querySelector('[data-ax-rail]');
        if (r) r.scrollBy({ left: (b.hasAttribute('data-ax-rail-next') ? 1 : -1) * 360, behavior: 'smooth' });
      });
    });
  }

  function init(root) { initHeader(root); initCarousel(root); initDiff(root); initFilters(root); initFaq(root); initPricing(root); initRails(root); }
  document.addEventListener('DOMContentLoaded', function () { init(document); initVideo(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
